import React from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import { TiEdit } from "react-icons/ti";

function AddressTag({
  value,
  item,
  createEditAddress,
  deleteAddress,
  isDisable,
}) {
  return (
    <div className="row">
      <div className="input-group mb-3">
        <input
          className="form-control"
          defaultValue="text"
          value={value}
          aria-label="readonly input example"
          readOnly
        />
        <button
          className="btn btn-warning"
          type="button"
          id="button-addon2"
          onClick={(event) => createEditAddress(event, item)}
          disabled={isDisable}
        >
          <TiEdit />
        </button>
        <button
          className="btn btn-danger"
          type="button"
          id="button-addon2"
          onClick={(event) => deleteAddress(event, item)}
          disabled={isDisable}
        >
          <RiDeleteBinLine />
        </button>
      </div>

      {/*<AddressView item={item} />*/}
    </div>
  );
}

export default AddressTag;
